// extracted by mini-css-extract-plugin
export var active = "_io-2";
export var recordingDot = "_io-1";
export var recordingIndicator = "_io-0";